import axios from 'axios'
import router from './router'
import store from './store/store'

let isAlreadyFetchingAccessToken = false

export const http = axios.create({
    baseURL: store.getters.endpoints.baseUrl,
    xhrFields: {
        withCredentials: true,
    },
    headers: {
        'Content-Type': 'application/json',
    },
})

export const httpBlob = axios.create({
    baseURL: store.getters.endpoints.baseUrl,
    xhrFields: {
        withCredentials: true,
    },
    headers: {
        'Content-Type': 'application/json',
        'Response-Type': 'blob',
    },
})

export const httpWill = axios.create({
    baseURL:
        process.env.NODE_ENV === 'production'
            ? 'https://www.mylastwill.co.uk/wills/api/'
            : 'http://127.0.0.1:8000/wills/api/',
    xhrFields: {
        withCredentials: true,
    },
    headers: {
        'Content-Type': 'application/json',
    },
})

const errorInterceptor = (error) => {
    switch (error.response.status) {
        case 401: // authentication error, logout the user
            console.log('catch 401')

            if (!isAlreadyFetchingAccessToken) {
                isAlreadyFetchingAccessToken = true

                return store
                    .dispatch('inspectToken')
                    .then((_) => {
                        isAlreadyFetchingAccessToken = false
                        error.config.headers[
                            'Authorization'
                        ] = `JWT ${store.getters.tokens.access}`
                        return axios.request(error.config)
                    })
                    .catch((error) => {
                        isAlreadyFetchingAccessToken = false
                        return error
                    })
            }

            store.commit(
                'loginError',
                'Authentication error ' + error.response.data.detail
            )
            break
        case 403: // Incorrect permission
            console.log('catch 403')
            router.push('/login').catch((err) => {})
            store.commit(
                'loginError',
                'Incorrect permissions (User must be staff) ' +
                    error.response.data.detail
            )
            break
        default:
            console.error('server error')
    }
    return Promise.reject(error)
}

const responseInterceptor = (response) => {
    switch (response.status) {
        case 200:
            break
        default:
            break
    }
    return response
}

http.interceptors.response.use(responseInterceptor, errorInterceptor)
httpWill.interceptors.response.use(responseInterceptor, errorInterceptor)
